<template>
	<div>
		<div>
			<div>
				<div>
					<div class="mb-5">
						<h4 class="uppercase font-bold block text-xl w-full">BÁO CÁO QUẢN LÝ CÔNG NỢ</h4>
					</div>

					<div class="mb-5">
						<vs-row>
							<vs-col vs-lg="2" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full pr-4">
									<label for class="text-base vs-input--label">
										Từ ngày:
									</label>
									<CbsDatePicker value-format="yyyy-MM-dd" name="from_date" :data-vv-as="'Thời gian'" class="w-full" v-model="from_date" type="date" placeholder="Theo vận đơn" :picker-options="pickerOptions" />
								</div>
							</vs-col>
							<vs-col vs-lg="2" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full pr-4">
									<label for class="text-base vs-input--label">
										Tới ngày:
									</label>
									<CbsDatePicker value-format="yyyy-MM-dd" name="to_date" :data-vv-as="'Thời gian'" class="w-full" v-model="to_date" type="date" placeholder="Theo vận đơn" :picker-options="pickerOptions" />
								</div>
							</vs-col>
							<vs-col vs-lg="2" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full pr-4">
									<label for class="text-base vs-input--label hide-on-mobile">
										&nbsp;
									</label>
									<vs-button class="vs-component vs-button font-bold" @click.stop="applySeeking()" style="display: block;">Tìm</vs-button>
								</div>
							</vs-col>
							<vs-col vs-lg="2" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full pr-4">
									<label for class="text-base vs-input--label">
										Nhập quỹ công ty:
									</label>
									<CbsMaskedInput
										dataType="int"
										class="vs-inputx vs-input--input normal"
										:userSetting="{}"
										v-model.number="nhap_quy_cong_ty"
										:disabled="1"
									/>
								</div>
							</vs-col>
							<vs-col vs-lg="2" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full pr-4">
									<label for class="text-base vs-input--label">
										Công nợ phải thu:
									</label>
									<CbsMaskedInput
										dataType="int"
										class="vs-inputx vs-input--input normal"
										:userSetting="{}"
										v-model.number="cong_no_phai_thu"
										:disabled="1"
									/>
								</div>
							</vs-col>
							<vs-col vs-lg="2" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full pr-4">
									<label for class="text-base vs-input--label">
										Tổng thu trong ngày:
									</label>
									<CbsMaskedInput
										dataType="int"
										class="vs-inputx vs-input--input normal"
										:userSetting="{}"
										v-model.number="tong_thu_trong_ngay"
										:disabled="1"
									/>
								</div>
							</vs-col>
							<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
								<vs-checkbox name="isMyData" v-model="isMyData" color="primary" id="isMyData" />
								<label for="isMyData" class="text-base vs-input--label">
									Chỉ hiện doanh thu của tôi
								</label>
							</vs-col>
						</vs-row>
					</div>

					<div class="mb-5 hide-on-mobile" v-if="nguoimuas.length">
						<label for class="text-base vs-input--label">
							Người mua hàng:
						</label>
						<div class="mt-3" style="align-items: center; display: flex;flex-direction: row;min-width: 100%;flex-wrap: wrap;">
							<div class="" :key="`${upStatus}-${idxStatus}`" v-for="(statusLabel, idxStatus) in nguoimuas" style="margin-right: 15px;">
								<vs-button class="font-bold mb-2" :color="'primary'" :type="statusLabel.active ? 'filled' : 'border'" @click="filterByStatus(idxStatus)">{{statusLabel.name}}</vs-button>
							</div>
						</div>
					</div>

					<div class="mb-5 hide-on-mobile" id="doanhsotable">
						<vs-table :sst="true" class="shadow-none border-none table-auto">
							<thead>
								<tr>
									<th rowspan="2" class="text-center">Doanh số</th>
									<th colspan="2" class="text-center">THU</th>
									<th rowspan="2" class="text-center">Công ty nhận</th>
									<th rowspan="2" class="text-center">Còn lại phải nộp</th>
								</tr>
								<tr>
									<th class="text-center">TM</th>
									<th class="text-center">CK</th>
								</tr>
							</thead>
							<tbody>
								<vs-tr>
									<vs-td class="text-center">{{ $helper.numFormat(doanh_so) }}</vs-td>
									<vs-td class="text-center">{{ $helper.numFormat(thu_tien_mat) }}</vs-td>
									<vs-td class="text-center">{{ $helper.numFormat(thu_chuyen_khoan) }}</vs-td>
									<vs-td class="text-center">{{ $helper.numFormat(cong_ty_nhan) }}</vs-td>
									<vs-td class="text-center">{{ $helper.numFormat(con_lai) }}</vs-td>
								</vs-tr>
							</tbody>
						</vs-table>
					</div>

					<div class="mb-5 show-on-mobile" id="doanhsotable">
						<vs-row>
							<vs-col vs-lg="12" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-2">
								<div class="w-full" style="display: flex; vertical-align: middle; justify-content: space-between;">
									<label for class="text-base vs-input--label">
										Doanh số:
									</label>
									<label for class="text-base vs-input--label font-bold text-right">
										{{ $helper.numFormat(doanh_so) }}
									</label>
								</div>
							</vs-col>
							<vs-col vs-lg="12" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-2">
								<div class="w-full" style="display: flex; vertical-align: middle; justify-content: space-between;">
									<label for class="text-base vs-input--label">
										Thu tiền mặt:
									</label>
									<label for class="text-base vs-input--label font-bold text-right">
										{{ $helper.numFormat(thu_tien_mat) }}
									</label>
								</div>
							</vs-col>
							<vs-col vs-lg="12" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-2">
								<div class="w-full" style="display: flex; vertical-align: middle; justify-content: space-between;">
									<label for class="text-base vs-input--label">
										Thu chuyển khoản:
									</label>
									<label for class="text-base vs-input--label font-bold text-right">
										{{ $helper.numFormat(thu_chuyen_khoan) }}
									</label>
								</div>
							</vs-col>

							<vs-col vs-lg="12" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-2">
								<div class="w-full" style="display: flex; vertical-align: middle; justify-content: space-between;">
									<label for class="text-base vs-input--label">
										Công ty nhận:
									</label>
									<label for class="text-base vs-input--label font-bold text-right">
										{{ $helper.numFormat(cong_ty_nhan) }}
									</label>
								</div>
							</vs-col>

							<vs-col vs-lg="12" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-2">
								<div class="w-full" style="display: flex; vertical-align: middle; justify-content: space-between;">
									<label for class="text-base vs-input--label">
										Còn lại phải nộp:
									</label>
									<label for class="text-base vs-input--label font-bold text-right">
										{{ $helper.numFormat(con_lai) }}
									</label>
								</div>
							</vs-col>
						</vs-row>
					</div>

					<div class="mb-5" v-if="phaithus.length">
						<label for class="text-base vs-input--label">
							Phải thu:
						</label>
						<vs-table :sst="true" class="shadow-none border-none table-auto" stripe :data="phaithus">
							<template slot="thead">
								<vs-th style="min-width:200px;"><h6 class="uppercase font-bold">Người mua</h6></vs-th>
								<vs-th style="min-width:120px;"><h6 class="uppercase font-bold">Vận đơn</h6></vs-th>
								<vs-th style="min-width:120px;"><h6 class="uppercase font-bold">Ngày giao</h6></vs-th>
								<vs-th style="min-width:150px;"><h6 class="uppercase font-bold">Số tiền</h6></vs-th>
							</template>
							<template slot-scope="{ data }">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data" @click.native="onClickEditOrder(tr, $event)">
									<vs-td>
										<p class="word-break">
											{{ tr.nguoi_mua }}
										</p>
									</vs-td>
									<vs-td>
										<p class="word-break">
											{{ tr.so_van_don }}
										</p>
									</vs-td>
									<vs-td>
										<p class="word-break">
											{{ $helper.momentFormat(tr.ngay_giao) }}
										</p>
									</vs-td>
									<vs-td>
										<p class="word-break">
											{{ $helper.numFormat(tr.so_tien) }}
										</p>
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</div>
			</div>
		</div>
		<ThuNganForm :isPopupActive="customerDialog" @closePopup="toggleCustomerDialog" :data="customerData" />
	</div>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import SelectAssigned from "@/components/select-assigned/SelectAssigned";
import CbsUploadRefCustom from "@/components/cbs-upload-ref/CbsUploadRefCustom";
import ListUploadMode from "@/components/cbs-upload-ref/ListUploadMode";
import CbsMaskedInput from "@/components/cbs-masked-input/CbsMaskedInput";
import ThuNganForm from "./ThuNganForm.vue";

export default {
	name: "ShippingDashboard",
	components: { vSelect, SelectAssigned, CbsUploadRefCustom, ListUploadMode, CbsMaskedInput, ThuNganForm },
	props: {
		// isPopupActive: {
		// 	type: Boolean,
		// 	required: true,
		// },
		data: {
			type: Object,
			default: () => {},
		},
	},
	watch: {
		isMyData() {
			this.tinhToanDuLieu(this.cachedResponse);
		},
	},
	data() {
		return {
			activeUserId: 0,
			isMyData: 0,
			nguoiMuaDuocChon: {},
			customerDialog: false,
			customerData: {},
			phaithus: [],
			nguoimuas: [],
			from_date: null,
			to_date: null,
			tong_thu_trong_ngay: null,
			cong_no_phai_thu: null,
			nhap_quy_cong_ty: null,
			doanh_so: null,
			thu_tien_mat: null,
			thu_chuyen_khoan: null,
			cong_ty_nhan: null,
			con_lai: null,
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			pickerOptions: {
				// disabledDate(time) {
				// 	return time.getTime() <= Date.now();
				// }
			},
			upStatus: Date.now(),
			cachedResponse: [],
		};
	},
	methods: {
		filterByStatus(idxStatus) {
			this.nguoimuas.map((status, index) => {
				if (index == idxStatus) {
					status.active = !status.active;
				}
			});
			this.tinhToanDuLieu(this.cachedResponse);
			this.upStatus = Date.now();
		},
		onClickEditOrder(data, event) {
			this.customerData = data;
			this.customerDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		toggleCustomerDialog(val = false) {
			this.customerDialog = val;
			if (!val) {
				this.customerData = {};
				this.getPaymentNos();
			}
		},
		applySeeking() {
			this.getPaymentNos();
		},
		uploadChungTu() {
			document.querySelector('#custom-upload .el-upload__input').click();
		},
		getValueByKey(order, key) {
			if (order.type == 1 && order.matching_buy) {
				return order.matching_buy[key] || '-';
			}
			if (order.type == 2 && order.matching) {
				return order.matching[key] || '-';
			}

			return '';
		},
		getDataMatching(key) {
			if (this.data2 && this.data2.matching && this.data2.matching.hasOwnProperty(key)) {
				return this.data2.matching[key];
			}
			return '';
		},
		async getPaymentNos() {
			this.$vs.loading();
			try {
				let payload = {id: 0, payno_text: this.payno_text, unc_text: this.unc_text, from_date: this.from_date, to_date: this.to_date, type: 'baocaothungan'};
				this.$store.dispatch("moduleProduct/getPaymentNos", payload).then(response => {
					this.cachedResponse = response;
					this.tinhToanDuLieu(response);

					this.$vs.loading.close();
				});

				this.$vs.loading.close();

				payload.type = 'baocaothunganall';
				this.$store.dispatch("moduleProduct/getPaymentNos", payload).then(response => {
					console.log('bao cao thu ngan all: ', response);
					let {nhap_quy_cong_ty = 0, cong_no_phai_thu = 0, tong_thu_trong_ngay = 0} = response || {};
					this.nhap_quy_cong_ty = nhap_quy_cong_ty;
					this.cong_no_phai_thu = cong_no_phai_thu;
					this.tong_thu_trong_ngay = tong_thu_trong_ngay;
				});
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		tinhToanDuLieu(response) {
			let chonNguoiMuaMap = {};
			this.nguoimuas.map(nguoimua => {
				if (nguoimua.active) {
					chonNguoiMuaMap[nguoimua.id] = nguoimua.name;
				}
			})
			// let cong_no_phai_thu = 0;
			let nhap_quy_cong_ty = 0;
			let doanh_so = 0;
			let thu_tien_mat = 0;
			let thu_chuyen_khoan = 0;
			let phaithus = [];
			let nguoimuas = [];
			let cachedNguoiMua = {};
			for (let k in response) {
				let tongTienTrenDon = 0;
				let tongThanhTrenDon = 0;
				let hoadon = response[k];
				if (hoadon.matching) {
					if (!cachedNguoiMua.hasOwnProperty(hoadon.matching.buyer_id)) {
						nguoimuas.push({
							id: hoadon.matching.buyer_id,
							name: hoadon.matching.cus_name,
						});
						cachedNguoiMua[hoadon.matching.buyer_id] = 1;
					}
					if (Object.keys(chonNguoiMuaMap).length && !chonNguoiMuaMap.hasOwnProperty(hoadon.matching.buyer_id)) {
						continue;
					}
				}
				if (hoadon.ketoan_detail) {
					tongTienTrenDon = parseFloat(hoadon.ketoan_detail.tong_tien || 0) - parseFloat (hoadon.ketoan_detail.khau_tru || 0);
					if (!this.isMyData) {
						doanh_so += tongTienTrenDon;
					}
				} 
				if (hoadon.thanhtoans) {
					for (let kk in hoadon.thanhtoans) {
						let uncTmp = hoadon.thanhtoans[kk];
						if (uncTmp) {
							let paymentValue = parseFloat(uncTmp.payment_value || 0);
							tongThanhTrenDon += paymentValue;

							if (this.isMyData) {
								if (uncTmp.created_by && uncTmp.created_by == this.activeUserId) {
									doanh_so += paymentValue;
									if (!uncTmp.payment_method || uncTmp.payment_method != 2) {
										thu_tien_mat += paymentValue;
										uncTmp.id = `${hoadon.id}_${uncTmp.payment_date}_${kk}`;
										uncTmp.payment_no = hoadon.matching ? hoadon.matching.cus_name : 'NA';
										if (uncTmp.hasOwnProperty('payment_files') && uncTmp.payment_files.length) {
											nhap_quy_cong_ty += paymentValue;
										}
									} else {
										thu_chuyen_khoan += paymentValue;
										nhap_quy_cong_ty += paymentValue;
									}
								}
							} else {
								if (!uncTmp.payment_method || uncTmp.payment_method != 2) {
									thu_tien_mat += paymentValue;
									uncTmp.id = `${hoadon.id}_${uncTmp.payment_date}_${kk}`;
									uncTmp.payment_no = hoadon.matching ? hoadon.matching.cus_name : 'NA';
									// if (!uncTmp.payment_files || uncTmp.payment_files.length < 1) {
									// 	// phaithus.push(uncTmp);
									// 	// cong_no_phai_thu += paymentValue;
									// } else {
									// 	nhap_quy_cong_ty += paymentValue;
									// }
									if (uncTmp.hasOwnProperty('payment_files') && uncTmp.payment_files.length) {
										nhap_quy_cong_ty += paymentValue;
									}
								} else {
									thu_chuyen_khoan += paymentValue;
									nhap_quy_cong_ty += paymentValue;
								}
							}
						}
					}
				}
				let conLaiTrenDon = tongTienTrenDon - tongThanhTrenDon;
				if (conLaiTrenDon > 0 || !tongTienTrenDon) {
					let phaiThuItem = _.cloneDeep(hoadon);
					phaithus.push({
						...phaiThuItem,
						nguoi_mua: hoadon.matching && hoadon.matching.buy ? hoadon.matching.buy.cus_name : 'N/A',
						so_van_don: hoadon.code,
						ngay_giao: hoadon.shipping_date,
						so_tien: conLaiTrenDon
					});
					// cong_no_phai_thu += conLaiTrenDon;
				}
			}
			// this.cong_no_phai_thu = cong_no_phai_thu;
			// this.nhap_quy_cong_ty = nhap_quy_cong_ty;
			this.doanh_so = doanh_so;
			this.thu_tien_mat = thu_tien_mat;
			this.thu_chuyen_khoan = thu_chuyen_khoan;
			this.cong_ty_nhan = nhap_quy_cong_ty;
			this.con_lai = doanh_so - nhap_quy_cong_ty;
			this.phaithus = phaithus;
			if (!Object.keys(chonNguoiMuaMap).length) {
				this.nguoimuas = nguoimuas;
			}
		},
		getProductName() {
			if (!this.product_id) {
				return '';
			}
			let pName = '';
			for (let k in this.$store.state.moduleProduct.products) {
				let p = this.$store.state.moduleProduct.products[k];
				if (p && p.id == this.product_id) {
					pName = p.name;
					return pName;
				}
			}
			return pName;
		},
		handleChangeFile(uploadedFiles) {
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.address = null;
			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const dataObj = {
						type: this.data.type,
						productId: this.product,
						quantity: this.quantity,
						price: this.price,
						address: this.address,
						photos: this.files.map(item => item.id),
					};

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			this.initValues();
			if (this.id) {
				this.$emit("closePopup");
			}
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Đặt lệnh thành công",
				},
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/createOrder", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		async setPaymentInfo() {
			let files = [];
			for (let k in this.payment_files) {
				let file = this.payment_files[k];
				if (file) {
					files.push(k);
				}
			}
			
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: this.$t("Actions.Confirm"),
				text: 'Xác nhận lưu giấy chuyển tiền này',
				// accept: () => this.deleteCustomer(customer._id),
				accept: async () => {
					try {
						// this.$vs.loading();
						let payload = {id: this.supplier ? this.supplier : 0, checked_ids: files, type: 'new', files: this.files};
						await this.$store.dispatch("moduleProduct/setPaymentInfoAqua", payload);
						this.$helper.notifySuccess({ context: this, options: {
							text: 'Đã lưu',
						}, });
						this.applySeeking();
						this.payment_nos = [];
					} catch (error) {
						console.log('error: ', error);
						this.$helper.notifyWarning({ context: this, options: {
							text: error,
						}, });
					} finally {
						this.$vs.loading.close();
					}
				},
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
	created() {
		// console.log('created: ', Date.now());
		// this.getOrder(true);
		if (this.$store.state.AppActiveUser) {
			let { id = 0 } = this.$store.state.AppActiveUser;
			this.activeUserId = id;
		} else {
			this.activeUserId = 0;
		}
	}
};
</script>

<style>
#custom-upload-history .el-upload--picture-card {
	display: none;
}
#doanhsotable .not-data-table {
	display: none !important;
}
.show-on-mobile {
	display: none;
}
@media only screen and (max-width: 600px) {
	.hide-on-mobile {
		display: none !important;
	}
	.show-on-mobile {
		display: block !important;
	}
}
</style>